import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2b8ccf22&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=2b8ccf22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ccf22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8ccf22')) {
      api.createRecord('2b8ccf22', component.options)
    } else {
      api.reload('2b8ccf22', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2b8ccf22&scoped=true&", function () {
      api.rerender('2b8ccf22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/tpm/detail.vue"
export default component.exports